import React from 'react'
import SuccessPage from '../success'

const SuccessPageFr = () => {
    return <SuccessPage languageCode="en" />
}

export default SuccessPageFr
